import { Drawer, Divider } from 'antd'
import { ReactNode } from 'react'
import { CloseIcon } from 'src/iconsV2'

interface CalendarDrawerMobileProps {
  open: boolean
  onClose: () => void
  title: string
  children: ReactNode
}

const CalendarDrawerMobile = ({ open, onClose, title, children }: CalendarDrawerMobileProps) => {
  return (
    <Drawer
      placement="bottom"
      open={open}
      onClose={onClose}
      height="auto"
      closable={false}
      rootClassName="calendar-drawer"
      className="rounded-xl"
    >
      <div className="p-4">
        <div className="flex justify-between items-center">
          <div className="text-xl font-semibold leading-7">{title}</div>
          <div onClick={onClose}><CloseIcon /></div>
        </div>
        <Divider className="my-4" />
        {children}
      </div>
    </Drawer>
  )
}

export default CalendarDrawerMobile
